<div class="border-t border-border dark:border-coal-100">
</div>
<div class="flex items-center justify-between flex-wrap gap-2 la:gap-5 my-5">
	<div class="flex flex-col gap-1">
		<h1 class="font-medium text-lg text-mono">
			Dashboard
		</h1>
		<div class="flex items-center gap-1 text-sm">
			<a class="text-secondary-foreground hover:text-primary" href="/metronic/tailwind/demo7/">
				Home
			</a>
			<span class="text-muted-foreground text-sm">
				/
			</span>
			<span class="text-secondary-foreground">
				Account
			</span>
			<span class="text-muted-foreground text-sm">
				/
			</span>
			<span class="text-mono">
				Dashboard
			</span>
		</div>
	</div>
	<div class="flex items-center flex-wrap gap-1.5 lg:gap-3.5">
		<a class="kt-btn kt-btn-outline" href="/metronic/tailwind/demo7/account/home/get-started">
			<i class="ki-filled ki-exit-down text-base!">
			</i>
			Export
		</a>
		<div class="kt-menu kt-menu-default" data-kt-menu="true">
			<div class="kt-menu-item kt-menu-item-dropdown" data-kt-menu-item-offset="0, 0"
				data-kt-menu-item-placement="bottom-end" data-kt-menu-item-toggle="dropdown"
				data-kt-menu-item-trigger="hover">
				<button class="kt-menu-toggle kt-btn kt-btn-outline flex-nowrap">
					<span class="flex items-center me-1">
						<i class="ki-filled ki-calendar text-base!">
						</i>
					</span>
					<span class="hidden md:inline text-nowrap">
						September, 2024
					</span>
					<span class="inline md:hidden text-nowrap">
						Sep, 2024
					</span>
					<span class="flex items-center lg:ms-4">
						<i class="ki-filled ki-down text-xs!">
						</i>
					</span>
				</button>
				<div class="kt-menu-dropdown w-48 py-2 kt-scrollable-y max-h-[250px]">
					<div class="kt-menu-item">
						<a class="kt-menu-link" href="#">
							<span class="kt-menu-title">
								January, 2024
							</span>
						</a>
					</div>
					<div class="kt-menu-item">
						<a class="kt-menu-link" href="#">
							<span class="kt-menu-title">
								February, 2024
							</span>
						</a>
					</div>
					<div class="kt-menu-item active">
						<a class="kt-menu-link" href="#">
							<span class="kt-menu-title">
								March, 2024
							</span>
						</a>
					</div>
					<div class="kt-menu-item">
						<a class="kt-menu-link" href="#">
							<span class="kt-menu-title">
								April, 2024
							</span>
						</a>
					</div>
					<div class="kt-menu-item">
						<a class="kt-menu-link" href="#">
							<span class="kt-menu-title">
								May, 2024
							</span>
						</a>
					</div>
					<div class="kt-menu-item">
						<a class="kt-menu-link" href="#">
							<span class="kt-menu-title">
								June, 2024
							</span>
						</a>
					</div>
					<div class="kt-menu-item">
						<a class="kt-menu-link" href="#">
							<span class="kt-menu-title">
								July, 2024
							</span>
						</a>
					</div>
					<div class="kt-menu-item">
						<a class="kt-menu-link" href="#">
							<span class="kt-menu-title">
								August, 2024
							</span>
						</a>
					</div>
					<div class="kt-menu-item">
						<a class="kt-menu-link" href="#">
							<span class="kt-menu-title">
								September, 2024
							</span>
						</a>
					</div>
					<div class="kt-menu-item">
						<a class="kt-menu-link" href="#">
							<span class="kt-menu-title">
								October, 2024
							</span>
						</a>
					</div>
					<div class="kt-menu-item">
						<a class="kt-menu-link" href="#">
							<span class="kt-menu-title">
								November, 2024
							</span>
						</a>
					</div>
					<div class="kt-menu-item">
						<a class="kt-menu-link" href="#">
							<span class="kt-menu-title">
								December, 2024
							</span>
						</a>
					</div>
				</div>
			</div>
		</div>
	</div>
</div>
<div class="border-b border-border mb-5 lg:mb-7.5">
</div>